import React from "react";
import { IoStarSharp } from "react-icons/io5";
import { Link as ScrollLink } from "react-scroll";

import CustomButton from "../../../../../../shared_components/CustomButton";

export const getNextStaurday = () => {

  const today = new Date();
  const day = today.getDay();
  let dayTillNextStaurday;
  if (day === 6 && today.getHours() >= 0) {
    dayTillNextStaurday = 7;
  } else {
    dayTillNextStaurday = (6 - day + 7) % 7;
  }

  const nextSaturday = new Date(today);
  nextSaturday.setDate(today.getDate() + dayTillNextStaurday);
  nextSaturday.setHours(0, 0, 0, 0);
  return nextSaturday.toLocaleDateString("en-UK", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

const HeroSection = () => {
  return (
    //fuction for setting the date of every next saturday
    <>
      <div className="row mx-0 justify-content-center herosection">
        <div className="col-12 px-0">
          <div className="row mx-0 justify-content-center">
            <div className="col-10 col-sm-8 col-md-5 px-0 ">
              <p className="align-items-center d-md-flex d-flex my-4 herosection-content">
                <a href="#" className="next-coding py-2 px-3 mx-auto">
                  Next Coding Class will be on {getNextStaurday()}
                  <span>
                    <i className="fa fa-arrow-right px-2" />
                  </span>
                </a>
              </p>
            </div>
          </div>
          <div className="row mx-0 justify-content-center">
            <div className="col-4 col-sm-4 col-md-2 col-lg-2 px-0 my-4">
              <h3 className="p-2 text-center minute">60-MINUTE INTRO CLASS</h3>
            </div>
          </div>
          <div className="row mx-0 justify-content-center">
            <div className="col-md-9 col-12 px-md-0 px-3">
              <h1 className="py-md-3 py-lg-3 pb-2 text-center free-class">
                <span>Free</span> Coding Class for Beginners
              </h1>
              <h2 className="text-center access-technology">
                Access a new career in Technology
              </h2>
              <p className=" py-md-3 py-lg-3 py-2 text-center learn-coding">
                Learn what coding is and how it can open up new career
                opportunities
              </p>
              <div className="text-center w-100">
                <ScrollLink
                  to="reserve-form"
                  offset={-90}
                  smooth={true}
                  duration={1000}
                >
                  <CustomButton
                    buttonName="Reserve my spot"
                    className="rounded-pill font-weight-bold py-md-3"
                  />
                </ScrollLink>
              </div>
              <div className="pt-3 mb-3 d-flex justify-content-center align-items-center">
                <p className="pr-3 m-0 mt-1 rate">4.9/5</p>
                <div className="">
                  <IoStarSharp className="fa fa-star py-0" />
                  <IoStarSharp className="fa fa-star py-0" />
                  <IoStarSharp className="fa fa-star py-0" />
                  <IoStarSharp className="fa fa-star py-0" />
                  <IoStarSharp className="fa fa-star py-0" />
                </div>
              </div>
              <h4 className="pb-5 text-center">
                Highly recommended by <span>20,000+</span> Students
              </h4>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default HeroSection;
